document.addEventListener("DOMContentLoaded", () => {

    if (!document.body.classList.contains("template-index")) return;

    function updateHeaderContrast(){

        const hero = document.querySelector('.banner img, .slideshow img');

        if(!hero) return;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = 20;
        canvas.height = 20;

        ctx.drawImage(hero,0,0,20,20);

        const pixels = ctx.getImageData(0,0,20,20).data;

        let total = 0;

        for(let i=0;i<pixels.length;i+=4){

            total +=
                pixels[i]*0.299 +
                pixels[i+1]*0.587 +
                pixels[i+2]*0.114;

        }

        const brightness = total / (pixels.length/4);

        document.body.classList.remove("header-light","header-dark");

        if(brightness > 140){
            document.body.classList.add("header-light");
        }else{
            document.body.classList.add("header-dark");
        }

    }

    window.addEventListener("load",updateHeaderContrast);

    setTimeout(updateHeaderContrast,500);

});